import { SUPPORTED_LOCALES } from '~/shared/constants/langConstants'

export const loadLanguageResources = async (lng: string, ns: string) => {
  const lang = SUPPORTED_LOCALES.includes(lng.toLowerCase())
    ? lng.toLowerCase()
    : 'en'
  try {
    return (await import(`~/assets/i18n/${lang}/${ns}.json`)).default
  } catch {
    return {}
  }
}
